import API from "api/axiosInstance";
import { setIsLoading, setListDivisi, setMessage, setStatus } from "./index";

export const fetchListDivisi = () => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.get("/divisi");
    dispatch(setIsLoading(false));
    dispatch(setListDivisi(response.data.data));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchAddNotifikasi = (redData) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.post("/send-notification", redData);
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(
      setMessage(error.response.data.message ?? "Ada Kendala di Server")
    );
    dispatch(setStatus("failed"));
  }
};
